// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Native System Dialog Overlay Styles (Image 2 Style) */

.mobile-invite-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.45);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  animation: mobileInviteFadeIn 0.2s ease-out;
}

@keyframes mobileInviteFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.mobile-invite-system-dialog {
  background: rgba(248, 248, 248, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 14px;
  width: 100%;
  max-width: 270px;
  text-align: center;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  animation: mobileInviteScaleUp 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes mobileInviteScaleUp {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.system-dialog-content {
  padding: 20px 16px 16px 16px;
}

.system-dialog-title {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: #000000;
  margin: 0 0 6px 0;
  line-height: 1.3;
}

.system-dialog-subtitle {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #3c3c43;
  margin: 0;
  line-height: 1.4;
  word-break: break-word;
}

.system-dialog-actions {
  display: flex;
  border-top: 0.5px solid rgba(60, 60, 67, 0.29);
  width: 100%;
}

.system-dialog-btn {
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 12px 8px;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, sans-serif;
  font-size: 17px;
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease;
  text-decoration: none;
}

.system-dialog-btn:active {
  background-color: rgba(0, 0, 0, 0.08);
}

.system-dialog-btn-cancel {
  font-weight: 400;
  color: #007aff;
  border-right: 0.5px solid rgba(60, 60, 67, 0.29);
}

.system-dialog-btn-open {
  font-weight: 600;
  color: #007aff;
}

.system-dialog-error {
  background-color: #ffebe9;
  color: #d9381e;
  font-size: 12px;
  padding: 8px 12px;
  margin-top: 8px;
  border-radius: 6px;
  line-height: 1.3;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing/components/MobileInviteLandingPage/MobileInviteLandingPage.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,qCAAqC;EACrC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,2EAA2E;AAC7E;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6FAA6F;EAC7F,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6FAA6F;EAC7F,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,6FAA6F;EAC7F,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* Native System Dialog Overlay Styles (Image 2 Style) */\r\n\r\n.mobile-invite-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 99999;\r\n  background-color: rgba(0, 0, 0, 0.45);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n  animation: mobileInviteFadeIn 0.2s ease-out;\r\n}\r\n\r\n@keyframes mobileInviteFadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.mobile-invite-system-dialog {\r\n  background: rgba(248, 248, 248, 0.95);\r\n  backdrop-filter: blur(20px);\r\n  -webkit-backdrop-filter: blur(20px);\r\n  border-radius: 14px;\r\n  width: 100%;\r\n  max-width: 270px;\r\n  text-align: center;\r\n  overflow: hidden;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n  animation: mobileInviteScaleUp 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n}\r\n\r\n@keyframes mobileInviteScaleUp {\r\n  from {\r\n    transform: scale(0.9);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.system-dialog-content {\r\n  padding: 20px 16px 16px 16px;\r\n}\r\n\r\n.system-dialog-title {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"SF Pro Text\", \"Segoe UI\", Roboto, sans-serif;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n  color: #000000;\r\n  margin: 0 0 6px 0;\r\n  line-height: 1.3;\r\n}\r\n\r\n.system-dialog-subtitle {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"SF Pro Text\", \"Segoe UI\", Roboto, sans-serif;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  color: #3c3c43;\r\n  margin: 0;\r\n  line-height: 1.4;\r\n  word-break: break-word;\r\n}\r\n\r\n.system-dialog-actions {\r\n  display: flex;\r\n  border-top: 0.5px solid rgba(60, 60, 67, 0.29);\r\n  width: 100%;\r\n}\r\n\r\n.system-dialog-btn {\r\n  flex: 1;\r\n  background: transparent;\r\n  border: none;\r\n  padding: 12px 8px;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"SF Pro Text\", \"Segoe UI\", Roboto, sans-serif;\r\n  font-size: 17px;\r\n  cursor: pointer;\r\n  outline: none;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.15s ease;\r\n  text-decoration: none;\r\n}\r\n\r\n.system-dialog-btn:active {\r\n  background-color: rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.system-dialog-btn-cancel {\r\n  font-weight: 400;\r\n  color: #007aff;\r\n  border-right: 0.5px solid rgba(60, 60, 67, 0.29);\r\n}\r\n\r\n.system-dialog-btn-open {\r\n  font-weight: 600;\r\n  color: #007aff;\r\n}\r\n\r\n.system-dialog-error {\r\n  background-color: #ffebe9;\r\n  color: #d9381e;\r\n  font-size: 12px;\r\n  padding: 8px 12px;\r\n  margin-top: 8px;\r\n  border-radius: 6px;\r\n  line-height: 1.3;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
